export const DistrictCodes = {
  Edmonton: { code: '343', label: 'Edmonton - 343' },
  Northeast: { code: '215', label: 'Northeast - 215' },
  Northwest: { code: '117', label: 'Northwest - 117' },
  Central: { code: '426', label: 'Central - 426' },
  Calgary: { code: '568', label: 'Calgary - 568' },
  South: { code: '623', label: 'South - 623' },
  CSD: { code: '353', label: 'CSD - 353' },
};
